<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="inertia-link"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.show,
                    },
                    {
                        name: $tc('messages.rubrics', 1),
                        href: meta.links.rubric_show,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.otherStudents"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>

        <div class="flex space-x-2 items-center">
            <img
                :src="student.avatar_or_default"
                :alt="student.full_name"
                :title="student.full_name"
                class="rounded-full h-10"
            />
            <div>{{ student.full_name }}</div>
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <RubricGrade v-model="form.rubric" :ranges="ranges" />

            <div class="flex justify-between mt-5">
                <div>
                    <AppButton
                        desired-action
                        element="button"
                        type="submit"
                        @click="saveAndPrevious()"
                        v-if="meta.links.previous"
                    >
                        {{ $t('messages.save_and_previous') }}
                        <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                    </AppButton>
                </div>
                <div>
                    <AppButton desired-action element="button" type="submit" @click="saveAndExit()">
                        {{ $t('messages.save_and_exit') }}
                        <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                    </AppButton>
                </div>
                <div>
                    <AppButton
                        desired-action
                        element="button"
                        type="submit"
                        @click="saveAndNext()"
                        v-if="meta.links.next"
                    >
                        {{ $t('messages.save_and_next') }}
                        <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                    </AppButton>
                </div>
            </div>

            <div class="mt-1">
                <FormLabel :value="$t('messages.internal_teacher_note')" for="comment" />
                <FormTextarea
                    rows="1"
                    id="comment"
                    v-model="form.comment"
                    name="comment"
                    type="text"
                    class="mt-1 w-full"
                />
                <FormError :value="form.errors.comment" />
            </div>

            <div class="mt-1">
                <FormLabel :value="$t('messages.feedback_for_students')" for="feedback" />
                <FormTextarea
                    rows="3"
                    id="feedback"
                    v-model="form.feedback"
                    name="feedback"
                    type="text"
                    class="mt-1 w-full"
                />
                <FormError :value="form.errors.feedback" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import GradeTranslator from '@/classes/GradeTranslator.js';
import RubricGrade from '@/Pages/Teacher/Activities/Rubrics/RubricGrade.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';

export default {
    components: {
        RubricGrade,
        PanelPage,
        AppButton,
        ActivityMenuOptions,
        FormLabel,
        FormTextarea,
        FormError,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'student', 'activity', 'ranges', 'activityResponse'],
    data() {
        return {
            gradeTranslator: new GradeTranslator(this.ranges),
            form: this.$inertia.form({
                student_id: this.student.id,
                rubric: JSON.parse(JSON.stringify(this.activity.rubric)),
                redirect_url: null,
                comment: this.activityResponse.comment,
                feedback: this.activityResponse.feedback,
            }),
        };
    },
    methods: {
        saveAndNext() {
            this.form.redirect_url = this.meta.links.next;
        },
        saveAndPrevious() {
            this.form.redirect_url = this.meta.links.previous;
        },
        saveAndExit() {
            this.form.redirect_url = this.meta.links.rubric_show;
        },
        submit() {
            this.form.patch(this.meta.links.update, {
                preserveState: false,
            });
        },
    },
};
</script>
